export default __webpack_public_path__ + "static/media/stageIcon.b254d284.svg";